import styled from "styled-components";

export const PhotoAiEntryStyled = styled.button`
  border: none;
  background: #f3f0ff;
  color: #6d5bd0;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.35rem 0.65rem;
  cursor: pointer;
  white-space: nowrap;
`;
